import React from "react";
import { useParams } from "react-router-dom";

import { e1, e2, e3, e4, e5, e6 } from "../assets/ecotopia";
import { s1, s2, s3, s4, s5, s6 } from "../assets/shakti";
import { a1, a2, a3, a4, a5, a6 } from "../assets/avanti";

const ecotopia = [e1, e2, e3, e4, e5, e6];
const shakti = [s3, s5, s2, s4, s1, s6];
const avanti = [a1, a5, a2, a3, a4, a6];

function DetailsGallery({ projectId }) {
  const { project } = useParams();

  return (
    <div className="my-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {project === "project-ecotopia" &&
          ecotopia.map((item, index) => (
            <img key={index} src={item} alt={item} className="rounded-lg" />
          ))}
        {project === "project-shakti" &&
          shakti.map((item, index) => (
            <img key={index} src={item} alt={item} className="rounded-lg" />
          ))}
        {project === "project-avanti" &&
          avanti.map((item, index) => (
            <img key={index} src={item} alt={item} className="rounded-lg" />
          ))}
      </div>
    </div>
  );
}

export default DetailsGallery;
